<template>
    <!-- 客观题 -->
    <div class="singleChoiceContent">
        <div v-for="(item,index) in questionlist" :key="index">
            <!-- 单项选择 -->
            <SingleC :itmData="item"  v-if="item.questiontype === 1"/>
            <!-- 多项选择 -->
            <MultipleChoice :itmData="item" v-if="item.questiontype == 2 || item.questiontype == 3" />
            <!-- 判断题 -->
            <Judge :itmData="item" v-if="item.questiontype == 4" />
            <!-- 填空题 -->
            <Completion :itmData="item" v-if="item.questiontype == 5"  />
            <!-- 材料题 -->
            <MaterialQuestions :itmData="item" v-if="item.questiontype == 7 && item.hasChoose" />
        </div>
    </div>
</template>
<script>
import MultipleChoice from './multipleChoice.vue'//多选
import Judge from './judge.vue'//判断题
import Completion from './completion.vue'//填空题
import MaterialQuestions from './materialQuestions.vue'//材料题
import SingleC from './singleC.vue'
// import QsAndAns from './qsAndAns.vue'
import {readOverCourseExam} from '@/api/measApi/teachManagement.js'
export default {
    data(){
        return {
            radio: '',
        }
    },
    props: {
        questionlist: {
            type: Array
        }
    },
    components: {
        MultipleChoice,
        Judge,
        Completion,
        MaterialQuestions,
        SingleC,
        // QsAndAns
    },
    methods: {
        readOverCourseExam(){
            readOverCourseExam().then(res => {
                console.log(res,'res')
            })
        }
    }
}
</script>
<style lang="scss">
.ans{
    margin-left: 10px;
}
.singleChoiceContent{
    .el-radio{
        margin-right: 0;
    }
    .itemConte{
        padding: 10px;
        // background: #f6f6f6;
        box-sizing: border-box;
        margin-bottom: 10px;
        h5{
            font-size: 16px;
            display: flex;
            align-items: center;
        }
        .analysis{
            color: #666666;
            display: flex;
        }
        .resAns{
            background: #f6f6f6;
            padding: 20px;
            margin-top: 10px;
        }
        .resBox{
            .res{
                display: flex;
                align-items: center;
                .icon{
                    font-size: 16px;
                }
                .resIConErr{
                    color: #d51b1b;
                }
                .resIconOk{
                    color: #0cb760;
                }
                .hide{
                    visibility: hidden;
                }
                .resDesc{
                    color: #0cb760!important;
                }
            }
        }
    }
    .indexConte{
        .resBox{
            display: flex;
            .res{
                display: flex;
                align-items: center;
                .icon{
                    font-size: 18px;
                }
            }
            .line{
                // margin-top: -10px;
                min-width: 120px;
                // padding: 0 20px;
                border-bottom: 1px solid #666666;
            }
            .index{
                height: 14px;
                width: 15px;
                border: 1px solid #666666;
                line-height: 14px;
                text-align: center;
                font-size: 12px;
                border-radius: 50%;
            }
        }
    }
    .CnConte{
        .itemInfo{
            font-size: 14px;
        }
    }
}
</style>